import { IS_PROD } from "domains/commons/environment";

export const ExploreTabs: Record<string, string> = {
  "Character Design": "asset_zBvfQJk62SedJse2AimU6h1g",
  "Creatures & Monsters": "asset_5YHQhvV27bqSD4wwFB8DELb5",
  "Book Illustrations": "asset_ZcWSCt7PZnHtppmSV9AYVjar",
  Props: "asset_6aDu6q4TYY9Erzku4NFupAm7",
  Weapons: "asset_wu2orMrRJmjgWVK2a81czSYs",
  Fantasy: "asset_u5YKnHpg5rUx1gQnZeeM6wz5",
  "Stylized Art": "asset_iDUSXqHk3xK8oJYdeGUtLKAr",
  "Horror & Dark Art": "asset_f52SAvgLoUQK6a6Lsfit27LJ",
  "Environmental Design": "asset_T6cRrJV9wdkQKoGyfjuWp5kr",
  "Level Art": "asset_gpn5HD97gZWU9o3wmYoVBQ15",
  "Buildings & Structures": "asset_d2V73NoxmpdUnpENjzA82Awm",
  "Mecha & Mechanical Design": "asset_GXyYZCsxZX5PC5qXHztU9UaL",
  "Science Fiction": "asset_U4gVfYo1vcD6EgzVSaC2yaFr",
  "3D Render": "asset_VWJG4jShp566CgRGxGMVLqDn",
  "UI & Icons": "asset_15gf9cTZB15KPAQhcvQK6Uoq",
  Typography: "asset_pWGaqMqvm3zk6GQX2Miq8syx",
  Storyboards: "asset_7mbd2yL9AHtJfCWJKymwEk3n",
  "Concept Art": "asset_UjmgDuQR5Hsc6h6xtQWDa5WE",
  "Casual & Mobile": "asset_FGqE8Bk3f6ED4N2vQBGvJUWT",
  Vehicles: "asset_p4XGHZ9tCK5DMxNVTgsVmDyY",
  "Board & Card Game Art": "asset_RkVWdKjmUPM4EfJqgvcE8MoN",
  Abstract: "asset_JbUJbPAZE6kig1kG9rpfoPeJ",
  "Textures & Materials": "asset_NjNeraE3zdaXhsukRZ4dA7se",
  Photorealism: "asset_gdRTUcR4pJ6Y61TWEK6pGQEk",
  "Animals & Wildlife": "asset_6WnGQQNwzz8XEMJ3vMaPSr8z",
  Portraits: "asset_jLzTycBaXXzFyoPMss8hn3ew",
  "Anime & Manga": "asset_9XrPpB7ZDrDvc7BccVEk22ko",
  "Comic Art": "asset_fXUwWcJGYjjVWqLybpgSUcy8",
  "Historical & Medieval": "asset_QkqEC8ecHPoJEyquXPUj86L3",
  Sketches: "asset_rcm191AnKnuxCB4EvCaeKbvM",
  "Digital Illustration & Painting": "asset_BEA96HMQU6dkx7t1xFZHjELn",
  Photography: "asset_hyeEenmAvwcFv6xqjFS4jJXk",
};

export function getCustomAssetId(tag: string, defaultAssetId: string): string {
  if (IS_PROD && tag in ExploreTabs) {
    return ExploreTabs[tag];
  } else {
    return defaultAssetId;
  }
}
